import React from 'react'

export default function TermsOfUse() {
  return (
    <div className="container mt-5 bg-white p-2">
      <h1>End User License Agreement (EULA) for Membotic</h1>
      <p><strong>Last Updated:</strong> 11/02/2025</p>
      <p>
        This End User License Agreement (“Agreement”) is a legal agreement between you (“User”) and Membotic Ltd, the creator of Membotic (“Application”). By installing, accessing, or using the Application, you agree to be bound by the terms of this Agreement.
      </p>

      <h3>1. License Grant</h3>
      <p>We grant you a limited, non-exclusive, non-transferable, revocable license to use the Application for personal or business purposes in accordance with this Agreement.</p>

      <h3>2. Restrictions</h3>
      <p>You agree not to:</p>
      <ul>
        <li>Copy, modify, or create derivative works of the Application.</li>
        <li>Violate the rights of others, including intellectual property, privacy, or publicity rights.</li>
        <li>Introduce any viruses, malware, or other harmful code into the Application.</li>
        <li>Reverse engineer, decompile, or disassemble the Application.</li>
        <li>Use the Application for any unlawful purpose or in violation of any applicable law.</li>
        <li>Share your access credentials or use the Application in a manner that exceeds the scope of your license.</li>
        <li>Not to upload, post, or transmit any content that:
          <ul>
            <li>Is sexual, explicit, or pornographic.</li>
            <li>Is offensive, abusive, defamatory, or hateful.</li>
            <li>Is discriminatory based on race, gender, religion, nationality, disability, sexual orientation, or age.</li>
            <li>Is violent or promotes violence.</li>
            <li>Infringes upon any intellectual property rights, including copyrights, trademarks, or patents.</li>
            <li>Violates any laws, regulations, or third-party rights.</li>
          </ul>
        </li>
      </ul>

      <h3>3. User Responsibilities</h3>
      <p>When using the Application, you agree to the following:</p>
      <ul>
        <li>Any club you create or register on the Application:
          <ul>
            <li>Must be a legitimate, existing entity.</li>
            <li>Must be owned, managed, or legally represented by you.</li>
          </ul>
        </li>
        <li>As a club owner, you must:
          <ul>
            <li>Accurately authenticate your identity and ownership when requested.</li>
            <li>Provide truthful and verifiable information about yourself and your club.</li>
          </ul>
        </li>
        <li>Misrepresentation of a club, its ownership, or your identity may result in the removal of the club from the Application and the termination of your access.</li>
      </ul>

      <h3>4. User Content Ownership</h3>
      <p>You retain ownership of the content you upload or share within the Application. By submitting content, you grant the Company a non-exclusive, royalty-free, worldwide license to use, modify, and display the content solely for the purpose of operating and improving the Application.</p>

      <h3>5. Account Security</h3>
      <p>You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify the Company immediately if you suspect any unauthorized access to your account.</p>

      <h3>6. Third-Party Links and Services</h3>
      <p>The Application may contain links to third-party websites or services that are not owned or controlled by the Company. The Company is not responsible for the content, privacy policies, or practices of third-party websites or services.</p>

      <h3>7. Force Majeure</h3>
      <p>The Company will not be liable for any failure to perform its obligations due to events beyond its reasonable control, such as natural disasters, government actions, or technical issues.</p>

      <h3>8. Ownership</h3>
      <p>All rights, title, and interest in the Application, including but not limited to its software, features, and design, remain the exclusive property of the Company.</p>

      <h3>9. Privacy and Data Collection</h3>
      <p>Use of the Application is subject to our Privacy Policy, which explains how we collect, use, and share information.</p>

      <h3>10. Updates</h3>
      <p>We may release updates or modifications to the Application. Continued use after such updates constitutes acceptance of the updated Application and terms.</p>

      <h3>11. Termination</h3>
      <p>This Agreement is effective until terminated. We reserve the right to terminate your license and access to the Application at any time for a breach of this Agreement.</p>

      <h3>12. Disclaimer of Warranties</h3>
      <p>The Application is provided “as is” without any warranties, express or implied, including but not limited to merchantability, fitness for a particular purpose, or non-infringement.</p>

      <h3>13. Limitation of Liability</h3>
      <p>To the maximum extent permitted by law, the Company shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of the use or inability to use the Application. The Company is not liable for any illegal activities or fraudulent actions performed by users while using the Application. Users are solely responsible for ensuring their actions comply with all applicable laws, and for any fraudulent activity they engage in.</p>

      <h3>14. Indemnification</h3>
      <p>You agree to indemnify and hold harmless the Company from any claims, damages, liabilities, and expenses arising from your use of the Application or violation of this Agreement.</p>

      <h3>15. Governing Law</h3>
      <p>This Agreement shall be governed by and construed in accordance with the laws of England and Wales.</p>

      <h3>16. Contact Information</h3>
      <p>For questions or concerns about this Agreement, contact us at <a href="mailto:info@membotic.com">info@membotic.com</a></p>
    </div>
  );
}
